export default "__VITE_ASSET__CKgDCANl__"